import { createStore } from '@orderx/lab/xr/store';
import { useGeolocation } from './geolocation';
import { apiPublicBrowsePost } from '../api/public.browse.[post]';
import { useCallback } from 'react';

interface Store {
    isLoadingFeed: boolean;
    feed: {
        nearby: any[];
        away: any[];
    };
}

const { useStore } = createStore<Store>({
    isLoadingFeed: false,
    feed: {
        nearby: [],
        away: [],
    },
});

export function useBrowseFeed() {
    const [state, setState] = useStore();
    const { coordinates } = useGeolocation();

    const loadFeed = useCallback(async () => {
        setState((state) => {
            state.isLoadingFeed = true;
        });

        try {
            const response = await apiPublicBrowsePost({
                body: {
                    latitude: coordinates?.latitude,
                    longitude: coordinates?.longitude,
                },
            });

            setState((state) => {
                state.feed = response;
            });
        } catch (error) {
            console.error(error);
        }

        setState((state) => {
            state.isLoadingFeed = false;
        });
    }, [coordinates]);

    return {
        loadFeed,

        feed: [...state.feed.nearby, ...state.feed.away],

        feedNearby: state.feed.nearby,

        feedAway: state.feed.away,
    };
}
